import _ from 'lodash';
import React, { FC, useCallback, useEffect, useRef } from 'react';

interface Props {
    loading?: boolean;
    onNext: (width: number) => void;
    hasMore: boolean;
    loader?: React.ReactNode;
    children: React.ReactNode; //table component antd
    infiniteScrollerStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    scrollThreshold?: number;
    scrollableTarget?: string;
    id: string;
    toScrollWidth?: number;
    additionalDependency?: any[];
}
//horizontal infinite scroller component
const HorizontalInfiniteScroller: FC<Props> = ({
    children,
    hasMore = false,
    scrollThreshold = 1, //scroll threshold
    onNext, //function called when scrollbar reaches the threshold
    id = '', //id of the child component which has overflow setup`
    toScrollWidth = 0,
    additionalDependency = [],
}) => {
    const isOnNextCalled = useRef<boolean>(false);

    //throttled onscroll function
    const throttleFn = useCallback(_.throttle(onScroll, 200), [hasMore, toScrollWidth, ...additionalDependency]);

    //onScroll function
    function onScroll() {
        const scrollContainerElement = document.getElementById(id);
        if (scrollContainerElement && hasMore) {
            const maxThreshold = Math.floor(Number(scrollContainerElement?.scrollWidth * scrollThreshold));
            //when scrollbar reaches max threshold, enable call onNext function
            const limit = scrollContainerElement?.offsetWidth + scrollContainerElement?.scrollLeft >= maxThreshold;
            if (limit && !isOnNextCalled.current && hasMore) {
                isOnNextCalled.current = true;
                onNext(maxThreshold - scrollContainerElement?.offsetWidth);
            } else if (isOnNextCalled.current && hasMore && !limit) isOnNextCalled.current = false;
        }
    }
    useEffect(() => {
        const scrollContainerElement = document.getElementById(id);

        // function onScroll() {
        //     throttleFn(scrollContainerElement);
        // }
        if (Number(toScrollWidth) > 0) {
            scrollContainerElement?.scrollTo({
                left: toScrollWidth,
            });
        }
        if (hasMore) {
            scrollContainerElement?.addEventListener('scroll', throttleFn, { passive: true });
            //only scroll if toScrollWidth is a number
        }

        return () => {
            scrollContainerElement?.removeEventListener('scroll', throttleFn);
            isOnNextCalled.current = false;
        };
    }, [hasMore, toScrollWidth, ...additionalDependency]);
    return <React.Fragment>{children}</React.Fragment>;
};

export default HorizontalInfiniteScroller;
